interface ApiErrorAction {
  label: string;
  callback: () => void;
}

interface ApiErrorOptions {
  code?: string;
  meta?: unknown;
  info?: Record<string, unknown>;
  action?: ApiErrorAction;
  log?: boolean;
}

class ApiError extends Error {
  code?: string;
  meta?: unknown;
  info?: Record<string, unknown>;
  action?: ApiErrorAction;
  log: boolean;

  constructor(msg: string, { code, meta, info, action, log = true }: ApiErrorOptions = {}) {
    super(msg);
    this.code = code;
    this.meta = meta;
    this.info = info;
    this.action = action;
    this.log = log;
  }
}
export default ApiError;
